import React, { useEffect, useState } from "react";
import T from "prop-types";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import { update } from "MODULES/PurchaseOrders/actions";
import { connect } from "react-redux";
import { hasAnyOfRoles } from "MODULES/users/helpers";
import { useCurrentUser } from "APP_ROOT/hooks";
import { ACCOUNTING } from "MODULES/users/constants";
import api from "APP_ROOT/api";
import { get } from "lodash";
import { CREATED_AT, DISABLE_QB_SYNC, SYNC_DATE } from "APP_ROOT/constants";
import moment from "moment";
import { BUYING_STORE_ID } from "MODULES/PurchaseOrders/constants";

function ToggleQuickbooksSync({ onConfirm, purchaseOrder }) {
  const [visible, setVisible] = useState(false);
  const [settings, setSettings] = useState(null);

  if (!hasAnyOfRoles(useCurrentUser(), [ACCOUNTING])) {
    return null;
  }

  const createdAt = purchaseOrder.get(CREATED_AT);

  useEffect(
    () => {
      api.locations.locationSetting
        .show(purchaseOrder.get(BUYING_STORE_ID))
        .then(({ data }) => {
          setSettings(get(data, "settings.quickbooks", {}));

          return function cleanup() {};
        });
    },
    [createdAt]
  );

  const syncDate = get(settings, SYNC_DATE);

  if (!syncDate) return null;

  if (syncDate && moment(syncDate) <= moment(createdAt).format("YYYY-MM-DD")) {
    return null;
  }

  const quickbooksDisabled = purchaseOrder.get(DISABLE_QB_SYNC);

  return (
    <DropDownItem onClick={() => setVisible(true)}>
      <Icon name={quickbooksDisabled ? "play" : "pause"} fixed />
      &nbsp;{quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync"}
      <ConfirmAction
        onConfirm={onConfirm}
        close={() => setVisible(false)}
        open={visible}
        btnText={quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync"}
        cancelText="Cancel"
        icon={<i className="fa fa-fw fa-pause" />}
      >
        <strong>Heads up!</strong>
        &nbsp; Are you sure you want to{" "}
        {quickbooksDisabled ? "enable QB Sync" : "disable QB Sync"}?
      </ConfirmAction>
    </DropDownItem>
  );
}

export default connect(undefined, (dispatch, ownProps) => ({
  onConfirm: () =>
    dispatch(
      update({ disable_qb_sync: !ownProps.purchaseOrder.get(DISABLE_QB_SYNC) })
    )
}))(ToggleQuickbooksSync);

ToggleQuickbooksSync.propTypes = {
  onConfirm: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/ToggleQuickbooksSync/ToggleQuickbooksSync.jsx